/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */

import React from 'react'
import Step1Img from '../../assets/Images/Screenshot_1.png'
import Step2Img from '../../assets/Images/Screenshot_2.png'
import Step3Img from '../../assets/Images/Screenshot_3.png'

const Howwedoit = () => {
    return (
        <>
            <section className='mb-5'>
                <div className='container'>
                    <div className='row'>
                        <h1 className='text-center' style={{ color: "#2e3192" }}>HERE'S HOW WE DO IT</h1>

                        <div className='col-sm-4'>
                            <div className='text-center'>
                                <img src={Step1Img} />
                                <p className='mt-3'>  We assess Your needs and determine the level of monitoring you will require. </p>
                            </div>
                        </div>
                        <div className='col-sm-4'>
                            <div className='text-center'>
                                <img src={Step2Img} />
                                <p className='mt-3'>We get you set up, configuring and installing our smart equipment on site.  </p>
                            </div>
                        </div>
                        <div className='col-sm-4'>
                            <div className='text-center'>
                                <img src={Step3Img} />
                                <p className='mt-3'>We start collecting data in real time. We then derive actionable insights based on real-time data, whilst measuring effectiveness continuously. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Howwedoit

/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */